import { db } from '../../config/main_config';
// import { getAssignees } from './getAssignees.util';
import { getUsersList } from './getUsersList.util';

export const getCustomerUsers = async (customerId) => {
    try {
        let users = await getUsersList(customerId);
        console.log(`[Utilities] (getCustomerUsers) Got users:`, users);
        if (users === null) {
            return [];
        }

        let customerUsers = [];

        await db.collection('customers').doc(customerId).get().then(async (snapshot) => {
            let customerOrg = await snapshot.data().customerOrg;
            let userIDs = Object.keys(customerOrg.users);
            console.log(`[Utilities] (getCustomerUsers) Got user IDs:`, userIDs);
            const userMap = Object.fromEntries(users.map(u => [u.userID, u]));
            for (let userID of userIDs) {
                const user = userMap[userID];
                if (!user) {
                    continue;
                }
                console.log(`[Utilities] (getCustomerUsers) Comparing user ID:`, userID, user.userID);
                if (user.userID === userID) {
                    console.log(`[Utilities] (getCustomerUsers) Found matching user ID:`, userID, user.userID);
                    let tmpUser = {
                        ...customerOrg.users[userID],
                        ...user,
                    }
                    console.log(`[Utilities] (getCustomerUsers) Found matching user:`, tmpUser);
                    customerUsers.push(tmpUser);
                }
            }
        });

        return customerUsers;
    } catch (error) {
        console.error('[Utilities] (getCustomerUsers) Error fetching customer users:', error);
        return null;
    }
}